import React, { FC } from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';

export const Text: FC<TextProps> = (props) => {
  const { Text: AntdText } = Typography;
  return <AntdText style={props.style}>{props.children}</AntdText>;
};
